function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_19969",
  "data-name": "Group 19969",
  transform: "translate(-257.736 -1750.115)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18551",
  "data-name": "Group 18551",
  transform: "translate(-763.764 1065.115)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18531",
  "data-name": "Group 18531",
  transform: "translate(232.5 146)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_2205",
  "data-name": "Line 2205",
  x2: 45.5,
  transform: "translate(857 540)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2207",
  "data-name": "Line 2207",
  x2: 13.5,
  transform: "translate(794.5 585.213)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2206",
  "data-name": "Line 2206",
  x2: 25.5,
  transform: "translate(857 551)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2208",
  "data-name": "Line 2208",
  x2: 25.5,
  transform: "translate(789 594.213)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_18017",
  "data-name": "Group 18017",
  transform: "translate(879.75 588.213)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518",
  "data-name": "Rectangle 7518",
  width: 2,
  height: 12,
  rx: 1,
  transform: "translate(5)",
  fill: "#cad4dd"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519",
  "data-name": "Rectangle 7519",
  width: 2,
  height: 12,
  rx: 1,
  transform: "translate(12 5) rotate(90)",
  fill: "#cad4dd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_18018",
  "data-name": "Group 18018",
  transform: "translate(810.5 545)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518-2",
  "data-name": "Rectangle 7518",
  width: 2,
  height: 12,
  rx: 1,
  transform: "translate(5)",
  fill: "#cad4dd"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519-2",
  "data-name": "Rectangle 7519",
  width: 2,
  height: 12,
  rx: 1,
  transform: "translate(12 5) rotate(90)",
  fill: "#cad4dd"
}))), /*#__PURE__*/React.createElement("g", {
  id: "no-data-7713",
  transform: "translate(1157.83 831.784)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18550",
  "data-name": "Group 18550",
  transform: "translate(-95.045 -126.036)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31240",
  "data-name": "Path 31240",
  d: "M171.321,16.142h-7.98a2.564,2.564,0,0,1-2.561-2.561V5.6h2.159v7.98a.4.4,0,0,0,.4.4h7.98v2.159Z",
  transform: "translate(-135.768 -4.522)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31241",
  "data-name": "Path 31241",
  d: "M64.917,48.577H33.7a2.709,2.709,0,0,1-2.706-2.706V2.706A2.709,2.709,0,0,1,33.7,0H56.408a2.69,2.69,0,0,1,1.913.792L66.831,9.3a2.69,2.69,0,0,1,.792,1.913V45.871A2.709,2.709,0,0,1,64.917,48.577ZM33.7,2.159a.547.547,0,0,0-.547.547V45.872a.547.547,0,0,0,.547.547H64.917a.547.547,0,0,0,.547-.547V11.215a.543.543,0,0,0-.16-.387L56.8,2.319a.544.544,0,0,0-.387-.16Z",
  transform: "translate(-30.991)",
  fill: "#8c9cac"
})))), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3236",
  "data-name": "Ellipse 3236",
  cx: 10.5,
  cy: 10.5,
  r: 10.5,
  transform: "translate(307 1787)",
  fill: "#f3994e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32075",
  "data-name": "Path 32075",
  d: "M110.214,70.945a1.4,1.4,0,0,1-1.4-1.4V63.489a1.4,1.4,0,1,1,2.807,0v6.053A1.4,1.4,0,0,1,110.214,70.945Z",
  transform: "translate(207.387 1729.114)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32076",
  "data-name": "Path 32076",
  d: "M110.214,180.24a1.4,1.4,0,1,1,1.4-1.4A1.4,1.4,0,0,1,110.214,180.24Z",
  transform: "translate(207.387 1623.852)",
  fill: "#fff"
}));
function SvgNoDataSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.5,
    height: 69.324,
    viewBox: "0 0 113.5 69.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataSmall);
export default __webpack_public_path__ + "static/media/no-data-small.61c9a08c.svg";
export { ForwardRef as ReactComponent };